import React from 'react'
//filter icon
import { FaFilter } from "react-icons/fa";

//template images
import searchIcon from "../TemplateSection/Images/searchbarIcon.png";
import templateImg1 from "../TemplateSection/Images/templateImage1.png";
import templateImg2 from "../TemplateSection/Images/templateImage2.png";
import templateImg3 from "../TemplateSection/Images/templateImage3.png";
import templateImg4 from "../TemplateSection/Images/templateImage4.png";
import templateImg5 from "../TemplateSection/Images/templateImage5.png";
import templateImg6 from "../TemplateSection/Images/templateImage6.png";
import templateImg7 from "../TemplateSection/Images/templateImage7.png";
import templateImg8 from "../TemplateSection/Images/templateImage8.png";
import templateImg9 from "../TemplateSection/Images/templateImage9.png";
import templateImg10 from "../TemplateSection/Images/templateImage10.png";
import templateImg11 from "../TemplateSection/Images/templateImage11.png";
import templateImg12 from "../TemplateSection/Images/templateImage12.png";

const Templates = () => {
    const templates = [
        {
            id: 1,
            image: templateImg1,
            title: "Template 1"
        },

        {
            id: 2,
            image: templateImg2,
            title: "Template 2"
        },

        {
            id: 3,
            image: templateImg3,
            title: "Template 3"
        },

        {
            id: 4,
            image: templateImg4,
            title: "Template 4"
        },

        {
            id: 5,
            image: templateImg5,
            title: "Template 5"
        },

        {
            id: 6,
            image: templateImg6,
            title: "Template 6"
        },

        {
            id: 7,
            image: templateImg7,
            title: "Template 7"
        },

        {
            id: 8,
            image: templateImg8,
            title: "Template 8"
        },

        {
            id: 9,
            image: templateImg9,
            title: "Template 9"
        },

        {
            id: 10,
            image: templateImg10,
            title: "Template 10"
        },

        {
            id: 11,
            image: templateImg11,
            title: "Template 11"
        },

        {
            id: 12,
            image: templateImg12,
            title: "Template 12"
        },
    ];

    return (
        <section
            className="py-4 position-relative mb-5"
            style={{
                overflow: 'hidden',
                backgroundColor: '#F4F7FC',
                marginTop: '40px'
            }}
        >
            {/* Responsive image  */}
            <style>{`
        .template-img {
          width: 100%;
          height: 240px;
          object-fit: contain;
          border-radius: 16px;
          display: block;
        }
        /* xs default */
        .template-img { height: 320px; }
        /* md and up */
        @media (min-width: 768px) {
          .template-img { height: 440px; }
        }
        /* xl and up */
        @media (min-width: 1200px) {
          .template-img { height: 496px; }
        }
      `}</style>

            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative mb-5"
                style={{ maxWidth: '74%', zIndex: 1 }}
            >
                {/* Heading */}
                <div className="mb-4" >
                    <h2
                        style={{
                            fontSize: "2.5rem",
                            fontFamily: "Inter",
                            fontWeight: 700,
                            color: "#242121ff",
                            lineHeight: 1.2,
                            marginTop: "26px"
                        }}
                    >
                        Explore pre-built <span style={{ color: '#1DB954' }}>WhatsApp</span> templates for
                        <br />
                        every business scenario
                    </h2>
                </div>

                {/* SearchBar code  and filter code*/}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "16px",
                        width: "97%",
                    }}
                >
                    {/* Search Box */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            background: "rgba(255, 255, 255, 0.8)",
                            borderRadius: "50px",
                            padding: "10px 16px",
                            boxShadow: "inset 0 2px 6px rgba(0,0,0,0.08)",
                            maxWidth: "400px",
                            flex: 1,
                        }}
                    >
                        <input
                            type="text"
                            placeholder="Search Templates ..."
                            style={{
                                flex: 1,
                                border: "none",
                                outline: "none",
                                background: "transparent",
                                fontSize: "16px",
                                fontWeight: "500",
                                fontFamily: "'Inter', sans-serif",
                                color: "#302f2fff",
                            }}
                        />
                        <img
                            src={searchIcon}
                            alt="search"
                            style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                                filter:
                                    "invert(18%) sepia(3%) saturate(250%) hue-rotate(4deg) brightness(95%) contrast(97%)",
                            }}
                        />
                    </div>

                    {/* Filter Box */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            background: "rgba(255, 255, 255, 0.8)",
                            borderRadius: "35px",
                            padding: "10px 16px",
                            boxShadow: "inset 0 2px 6px rgba(0,0,0,0.09)",
                            cursor: "pointer",
                        }}
                    >
                        <FaFilter size={18} color="#302f2f" />
                        <span
                            style={{
                                marginLeft: "8px",
                                fontSize: "16px",
                                fontWeight: "500",
                                fontFamily: "'Inter', sans-serif",
                                color: "#302f2f",
                            }}
                        >
                            Filter
                        </span>
                    </div>
                </div>

                {/* Templates Grid: 12 items (4 per row, equal spacing) */}
                <div className="mt-5">
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 gx-4 gy-2">
                        {templates.map(t => (
                            <div className="col" key={t.id}>
                                <div className="card border-0 bg-transparent h-100" style={{ cursor: "pointer" }}>
                                    <img
                                        src={t.image}
                                        alt={t.title}
                                        className="template-img"
                                        loading="lazy"
                                        decoding="async"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </section>
    )
}

export default Templates
